import React, { useState, useEffect } from 'react';
import Navbar from '../navbar';
import TopNavbar from '../topnavbar';
import Footer from '../footer';
import '../../App.css';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const ROWS_PER_PAGE = 10;

const MONTHS = [
    { value: '1',  label: 'January'   },
    { value: '2',  label: 'February'  },
    { value: '3',  label: 'March'     },
    { value: '4',  label: 'April'     },
    { value: '5',  label: 'May'       },
    { value: '6',  label: 'June'      },
    { value: '7',  label: 'July'      },
    { value: '8',  label: 'August'    },
    { value: '9',  label: 'September' },
    { value: '10', label: 'October'   },
    { value: '11', label: 'November'  },
    { value: '12', label: 'December'  },
];

const LOAN_TYPE_COLORS = {
    'SALARY LOAN':   '#f6c23e',
    'CALAMITY LOAN': '#e74a3b',
};

// Export Format Column Mappings ─────────────────────────────────────────────────────────────────────────────
const FORMAT_A_COLS = [
    { header: '3-UserID (New)',     fromRecord: 'EmployeeId'        },
    { header: 'Billing Month',      fromRecord: 'DeductFromMonth',  displayOnly: true },
    { header: 'Billing Year',       fromRecord: 'DeductFromYear',   displayOnly: true },
    { header: 'Name',               fromRecord: 'EmployeeName'      },
    { header: 'Loan Code',          fromRecord: 'LoanCode'          },
    { header: 'Loan Desc',          fromRecord: 'LoanDesc'          },
    { header: 'Loan Granted',       fromRecord: 'LoanGrantedDate'   },
    { header: 'StartDate'                                            },
    { header: 'PrincipalAmt',       fromRecord: 'PrincipalAmount'   },
    { header: 'LoanAmt',            fromRecord: 'LoanAmount'        },
    { header: 'Amount Per Cut-Off', fromRecord: 'BatchInstalment'   },
    { header: 'Schedule',           fromRecord: 'Schedule'          },
    { header: 'GL'                                                   },
    { header: 'NO. OF MOS',         fromRecord: 'ActualInstallments'},
    { header: 'TOTAL'                                                },
    { header: 'REMARKS'                                              },
];

const FORMAT_B_COLS = [
    { header: 'ID',                         fromRecord: 'EmployeeId'           },
    { header: 'Employee Name',              fromRecord: 'EmployeeName'         },
    { header: 'Deduct From Year (YYYY)',    fromRecord: 'DeductFromYear'       },
    { header: 'Deduct From Month (mm)',     fromRecord: 'DeductFromMonth'      },
    { header: 'Deduct From Batch',          fromRecord: 'DeductFromBatch'      },
    { header: 'Loan Code',                  fromRecord: 'LoanCode'             },
    { header: 'Applicable Batch',           fromRecord: 'ApplicableBatch'      },
    { header: 'Loan Granted Date',          fromRecord: 'LoanGrantedDate'      },
    { header: 'Promissory Note Number',     fromRecord: 'PromissoryNoteNumber' },
    { header: 'Loan Reference Number'                                          },
    { header: 'Calculation Type',           fromRecord: 'CalculationType'      },
    { header: 'Prin_amount',                fromRecord: 'PrincipalAmount'      },
    { header: 'Loan Recovered'                                                 },
    { header: 'Interest Rate'                                                  },
    { header: 'Actual No. Of Installments', fromRecord: 'ActualInstallments'   },
    { header: 'Paid No. Of Installments'                                       },
    { header: 'Remarks',                    fromRecord: 'Remarks'              },
    { header: 'Main Amount',                fromRecord: 'LoanAmount'           },
    { header: 'Loan Type',                  fromRecord: 'LoanType'             },
    { header: 'Batch Instalment',           fromRecord: 'BatchInstalment'      },
];

const thStyle = (accent) => ({
    backgroundColor: accent,
    color:           '#fff',
    fontWeight:      '700',
    fontSize:        '11px',
    padding:         '10px 12px',
    textAlign:       'center',
    whiteSpace:      'nowrap',
    position:        'sticky',
    top:             0,
    zIndex:          1,
    borderRight:     '1px solid rgba(255,255,255,0.15)',
});

const tdStyle = {
    padding:     '9px 12px',
    fontSize:    '12px',
    color:       '#5a5c69',
    textAlign:   'center',
    borderTop:   '1px solid #e3e6f0',
    whiteSpace:  'nowrap',
    borderRight: '1px solid #e3e6f0',
};

const selectStyle = {
    border:          '1px solid #d1d3e2',
    borderRadius:    '5px',
    padding:         '5px 10px',
    fontSize:        '12px',
    color:           '#5a5c69',
    outline:         'none',
    height:          '34px',
    backgroundColor: '#fff',
    cursor:          'pointer',
};

// Export Helper ─────────────────────────────────────────────────────────────────────────────
const SKY_BLUE_COLS    = new Set(['PromissoryNoteNumber', 'LoanReferenceNumber', 'LoanRecovered', 'InterestRate', 'PaidInstallments', 'Remarks']);
const CURRENCY_COLS    = new Set(['PrincipalAmount', 'LoanAmount', 'AmountPerCutOff', 'TotalAmount', 'LoanRecovered']);
const HEADER_DARK_PINK = 'FFEF4774';
const HEADER_SKY       = 'FF87CEEB';
const CURRENCY_FMT     = '₱#,##0.00';

const makeHeaderStyleB = (argb) => ({
    fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb } },
    font:      { name: 'Arial', size: 10, bold: true, color: { argb: 'FF000000' } },
    alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
    border: {
        top:    { style: 'thin',   color: { argb: 'FFBFBFBF' } },
        left:   { style: 'thin',   color: { argb: 'FFBFBFBF' } },
        bottom: { style: 'medium', color: { argb: 'FF888888' } },
        right:  { style: 'thin',   color: { argb: 'FFBFBFBF' } },
    },
});

const headerStyleA = {
    font:      { name: 'Calibri', size: 11, bold: false, underline: true, color: { argb: 'FF000000' } },
    alignment: { horizontal: 'center', vertical: 'bottom', wrapText: false },
    border:    { bottom: { style: 'thin', color: { argb: 'FF000000' } } },
};

const dataFont     = { name: 'Calibri', size: 11 };
const dataFontBold = { name: 'Calibri', size: 11, bold: true };
const altRowFillB  = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF8F9FC' } };
const dataBorderB  = {
    top:    { style: 'hair', color: { argb: 'FFE3E6F0' } },
    left:   { style: 'hair', color: { argb: 'FFE3E6F0' } },
    bottom: { style: 'hair', color: { argb: 'FFE3E6F0' } },
    right:  { style: 'hair', color: { argb: 'FFE3E6F0' } },
};

// TablePage Component ─────────────────────────────────────────────────────────────────────────────
const TablePage = ({
    fmt, records, loading, fetchError, fetchRecords,
    search, setSearch,
    filterMonth, setFilterMonth,
    filterYear,  setFilterYear,
    page, setPage,
    doExport,
    onFilterChange,
}) => {
    const allCols = fmt === 'A' ? FORMAT_A_COLS : FORMAT_B_COLS;
    const cols    = allCols.filter(c => !c.displayOnly);
    const accent  = fmt === 'A' ? '#4e73df' : '#1cc88a';
    const title   = fmt === 'A'
        ? 'Payroll Report A — 3-UserID (PAGIBIG / SSS)'
        : 'Payroll Report B — Employee Wise Loan Details';

    const currentYear   = new Date().getFullYear();
    const availableYears = Array.from({ length: 10 }, (_, i) => currentYear - i);

    const filtered = records.filter(r => {
        const trimmed = search.trim();
        return !trimmed || (
            (r.EmployeeId?.toString().toLowerCase().trim()  || '').includes(trimmed.toLowerCase()) ||
            (r.EmployeeName?.toLowerCase().trim()           || '').includes(trimmed.toLowerCase())
        );
    });

    const totalPages = Math.max(1, Math.ceil(filtered.length / ROWS_PER_PAGE));
    const safePage   = Math.min(page, totalPages);
    const rows       = filtered.slice((safePage - 1) * ROWS_PER_PAGE, safePage * ROWS_PER_PAGE);
    const start      = filtered.length === 0 ? 0 : (safePage - 1) * ROWS_PER_PAGE + 1;
    const end        = Math.min(safePage * ROWS_PER_PAGE, filtered.length);

    const hasActiveFilters = search || filterMonth || filterYear;

    const clearFilters = () => {
        setSearch('');
        setFilterMonth('');
        setFilterYear('');
        fetchRecords();
    };

    const handleMonthChange = (val) => {
        setFilterMonth(val);
        setPage(1);
        const monthLabel    = MONTHS.find(m => m.value === val)?.label || '';
        const effectiveYear = filterYear || String(new Date().getFullYear());
        onFilterChange(monthLabel, effectiveYear);
    };

    const handleYearChange = (val) => {
        setFilterYear(val);
        setPage(1);
        const monthLabel = MONTHS.find(m => m.value === filterMonth)?.label || '';
        onFilterChange(monthLabel, val);
    };

    return (
        <div className="card shadow mb-4" style={{ border: `1px solid ${accent}22` }}>

            {/* Card Header */}
            <div className="card-header py-3" style={{ backgroundColor: '#fff', borderBottom: `2px solid ${accent}` }}>

                {/* Title row */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <h6 className="m-0 font-weight-bold" style={{ color: accent }}>
                            <i className="fas fa-file-excel" style={{ marginRight: '8px' }}></i>
                            {title}
                        </h6>
                        {!loading && !fetchError && (
                            <span style={{ backgroundColor: `${accent}14`, color: accent, border: `1px solid ${accent}30`, borderRadius: '12px', padding: '2px 10px', fontSize: '11px', fontWeight: '700' }}>
                                {records.length} records
                            </span>
                        )}
                    </div>

                    {/* Export Button */}
                    <button
                        onClick={() => doExport(fmt, filtered)}
                        disabled={loading || !!fetchError || records.length === 0}
                        style={{
                            backgroundColor: loading || fetchError || records.length === 0 ? '#d1d3e2' : accent,
                            color: '#fff', border: 'none', borderRadius: '5px',
                            padding: '6px 16px', fontSize: '12px', fontWeight: '700',
                            cursor: loading || fetchError || records.length === 0 ? 'not-allowed' : 'pointer',
                            display: 'flex', alignItems: 'center', gap: '6px', height: '34px',
                        }}
                    >
                        <i className="fas fa-file-excel"></i> Export
                    </button>
                </div>

                {/* Filter row */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px', flexWrap: 'wrap' }}>

                    {/* Search */}
                    <div style={{ position: 'relative', flex: '1', minWidth: '180px', maxWidth: '240px' }}>
                        <i className="fas fa-search" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#b7b9cc', fontSize: '11px', pointerEvents: 'none' }}></i>
                        <input
                            type="text"
                            placeholder="Search ID or name..."
                            value={search}
                            onChange={e => { setSearch(e.target.value); setPage(1); }}
                            style={{ ...selectStyle, paddingLeft: '28px', width: '100%' }}
                        />
                    </div>

                    <div style={{ width: '1px', height: '22px', backgroundColor: '#e3e6f0' }} />

                    {/* Month filter */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <i className="fas fa-calendar-alt" style={{ color: '#b7b9cc', fontSize: '11px' }}></i>
                        <select value={filterMonth} onChange={e => handleMonthChange(e.target.value)} style={{ ...selectStyle, minWidth: '130px' }}>
                            <option value="">All Months</option>
                            {MONTHS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                        </select>
                    </div>

                    {/* Year filter */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <i className="fas fa-calendar" style={{ color: '#b7b9cc', fontSize: '11px' }}></i>
                        <select value={filterYear} onChange={e => handleYearChange(e.target.value)} style={{ ...selectStyle, minWidth: '100px' }}>
                            <option value="">All Years</option>
                            {availableYears.map(y => <option key={y} value={y}>{y}</option>)}
                        </select>
                    </div>

                    {/* Clear filters */}
                    {hasActiveFilters && (
                        <button onClick={clearFilters} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#b7b9cc', fontSize: '16px', padding: '0 4px', display: 'flex', alignItems: 'center' }}>
                            <i className="fas fa-times"></i>
                        </button>
                    )}
                </div>
            </div>

            {/* Card Body */}
            <div className="card-body p-0">

                {/* Loading */}
                {loading && (
                    <div style={{ textAlign: 'center', padding: '60px 0', color: '#858796' }}>
                        <i className="fas fa-spinner fa-spin fa-2x"></i>
                        <div style={{ marginTop: '12px', fontSize: '13px' }}>Loading records...</div>
                    </div>
                )}

                {/* Fetch Error */}
                {!loading && fetchError && (
                    <div style={{ margin: '20px', backgroundColor: '#fde8e8', border: '1px solid #f5c6cb', borderRadius: '6px', padding: '14px 18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <i className="fas fa-exclamation-circle" style={{ color: '#e74a3b' }}></i>
                        <span style={{ color: '#721c24', fontSize: '13px', flex: 1 }}>Failed to load: {fetchError}</span>
                        <button onClick={fetchRecords} style={{ backgroundColor: '#e74a3b', color: '#fff', border: 'none', borderRadius: '4px', padding: '4px 12px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                            <i className="fas fa-redo"></i> Retry
                        </button>
                    </div>
                )}

                {/* Table */}
                {!loading && !fetchError && (
                    <>
                        {/* Row count bar */}
                        {filtered.length > 0 && (
                            <div style={{ padding: '8px 16px', backgroundColor: '#f8f9fc', borderBottom: '1px solid #e3e6f0', fontSize: '11px', color: '#858796', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                Showing {start}–{end} of <b style={{ margin: '0 2px' }}>{filtered.length}</b> record{filtered.length !== 1 ? 's' : ''}
                                {filtered.length !== records.length && (
                                    <span style={{ color: '#b7b9cc' }}>— filtered from {records.length} total</span>
                                )}
                            </div>
                        )}

                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ borderCollapse: 'collapse', width: '100%', backgroundColor: '#fff', tableLayout: 'auto' }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...thStyle(accent), position: 'sticky', left: 0, zIndex: 2 }}>#</th>
                                        {allCols.map(c => <th key={c.header} style={thStyle(accent)}>{c.header}</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.length === 0 ? (
                                        <tr>
                                            <td colSpan={allCols.length + 1} style={{ ...tdStyle, textAlign: 'center', padding: '50px', color: '#b7b9cc' }}>
                                                <i className="fas fa-inbox fa-2x" style={{ display: 'block', marginBottom: '10px' }}></i>
                                                {records.length === 0 ? 'No records found.' : 'No records match your filters.'}
                                            </td>
                                        </tr>
                                    ) : rows.map((r, idx) => {
                                        const rowNum = (safePage - 1) * ROWS_PER_PAGE + idx + 1;
                                        const rowBg  = idx % 2 === 0 ? '#fff' : '#f8f9fc';
                                        return (
                                            <tr key={idx} style={{ backgroundColor: rowBg }}>
                                                {/* Row number */}
                                                <td style={{ ...tdStyle, color: '#b7b9cc', fontSize: '11px', position: 'sticky', left: 0, backgroundColor: rowBg, zIndex: 1 }}>
                                                    {rowNum}
                                                </td>

                                                {allCols.map(c => {
                                                    const val = r[c.fromRecord];

                                                    // Loan Type badge
                                                    if (c.fromRecord === 'LoanType') {
                                                        const normalized = val?.toUpperCase().trim();
                                                        const allowed    = normalized === 'SALARY LOAN' || normalized === 'CALAMITY LOAN' ? normalized : null;
                                                        const color      = LOAN_TYPE_COLORS[allowed] || '#858796';
                                                        return (
                                                            <td key={c.header} style={tdStyle}>
                                                                {allowed
                                                                    ? <span style={{ backgroundColor: `${color}18`, color, borderRadius: '4px', padding: '2px 8px', fontSize: '11px', fontWeight: '700' }}>{allowed}</span>
                                                                    : <span style={{ color: '#b7b9cc' }}>—</span>}
                                                            </td>
                                                        );
                                                    }

                                                    // Currency columns
                                                    if (['PrincipalAmount', 'LoanAmount', 'AmountPerCutOff', 'TotalAmount', 'LoanRecovered'].includes(c.fromRecord)) {
                                                        return (
                                                            <td key={c.header} style={{ ...tdStyle, textAlign: 'right' }}>
                                                                {val != null && val !== '' ? `₱${Number(val).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '—'}
                                                            </td>
                                                        );
                                                    }

                                                    // Employee ID
                                                    if (c.fromRecord === 'EmployeeId') {
                                                        return <td key={c.header} style={{ ...tdStyle, fontWeight: '700', color: accent }}>{val || '—'}</td>;
                                                    }

                                                    // Employee Name
                                                    if (c.fromRecord === 'EmployeeName') {
                                                        return <td key={c.header} style={{ ...tdStyle, textAlign: 'left', fontWeight: '600', color: '#3a3b45' }}>{val || '—'}</td>;
                                                    }

                                                    // Display-only columns (Billing Month / Year)
                                                    if (c.displayOnly) {
                                                        return (
                                                            <td key={c.header} style={{ ...tdStyle, backgroundColor: idx % 2 === 0 ? '#fffbea' : '#fff8e1', color: '#b7860b', fontStyle: 'italic', fontSize: '11px' }}>
                                                                {val != null && val !== '' ? val : '—'}
                                                            </td>
                                                        );
                                                    }

                                                    // Default
                                                    return <td key={c.header} style={tdStyle}>{val != null && val !== '' ? val : '—'}</td>;
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        {totalPages > 1 && (
                            <div style={{ padding: '12px 16px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '14px' }}>
                                <button
                                    onClick={() => setPage(p => Math.max(1, p - 1))}
                                    disabled={safePage === 1}
                                    style={{ backgroundColor: safePage === 1 ? '#d1d3e2' : accent, color: '#fff', border: 'none', borderRadius: '5px', padding: '6px 14px', fontSize: '12px', fontWeight: '600', cursor: safePage === 1 ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}
                                >
                                    <i className="fas fa-chevron-left"></i> Previous
                                </button>
                                <span style={{ fontSize: '12px', color: '#858796' }}>Page {safePage} of {totalPages}</span>
                                <button
                                    onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                                    disabled={safePage === totalPages}
                                    style={{ backgroundColor: safePage === totalPages ? '#d1d3e2' : accent, color: '#fff', border: 'none', borderRadius: '5px', padding: '6px 14px', fontSize: '12px', fontWeight: '600', cursor: safePage === totalPages ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}
                                >
                                    Next <i className="fas fa-chevron-right"></i>
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

// Main Component ─────────────────────────────────────────────────────────────────────────────
function LoanTracker() {
    const facility = sessionStorage.getItem('facility') || '';

    const [activeTab,      setActiveTab]      = useState('A');
    const [records,        setRecords]        = useState([]);
    const [loading,        setLoading]        = useState(false);
    const [fetchError,     setFetchError]     = useState(null);
    const [toast,          setToast]          = useState(null);
    const [currentBilling, setCurrentBilling] = useState(null);

    const [searchA,      setSearchA]      = useState('');
    const [searchB,      setSearchB]      = useState('');
    const [filterMonthA, setFilterMonthA] = useState('');
    const [filterYearA,  setFilterYearA]  = useState('');
    const [filterMonthB, setFilterMonthB] = useState('');
    const [filterYearB,  setFilterYearB]  = useState('');
    const [pageA,        setPageA]        = useState(1);
    const [pageB,        setPageB]        = useState(1);

    useEffect(() => { fetchRecords(); }, []);

    const showToast = (msg, type = 'success') => {
        setToast({ msg, type });
        setTimeout(() => setToast(null), 3500);
    };

    const fetchRecords = async (month = '', year = '') => {
        setLoading(true);
        setFetchError(null);
        try {
            const role   = sessionStorage.getItem('role');
            const params = new URLSearchParams({ facility, role });
            if (month) params.append('month', month);
            if (year)  params.append('year',  year);

            const res = await fetch(`/api/loantracker/records?${params}`);
            if (!res.ok) throw new Error(`Server error: ${res.status}`);
            const data = await res.json();
            setRecords(Array.isArray(data) ? data : []);

            if (data.length > 0) {
                setCurrentBilling({ month: data[0].DeductFromMonth, year: data[0].DeductFromYear });
            } else {
                setCurrentBilling(null);
            }
        } catch (e) {
            setFetchError(e.message);
            setRecords([]);
        } finally {
            setLoading(false);
        }
    };

    // ── Export Handler ─────────────────────────────────────────────────────
    const doExport = async (fmt, data) => {
        if (!data.length) { showToast('No records to export.', 'warn'); return; }

        const cols = fmt === 'A' ? FORMAT_A_COLS : FORMAT_B_COLS;
        const wb   = new ExcelJS.Workbook();
        wb.creator = 'LoanTracker';
        wb.created = new Date();

        const sheetName = fmt === 'A' ? 'Loan Report (Format A)' : 'Loan Report (Format B)';
        const ws        = wb.addWorksheet(sheetName);
        ws.views        = [{ state: 'frozen', ySplit: 1 }];
        ws.columns      = cols.map(c => ({ header: c.header, key: c.fromRecord, width: 10 }));
        ws.getRow(1).height = fmt === 'A' ? 15 : 30;

        ws.getRow(1).eachCell((cell, colNumber) => {
            const colDef = cols[colNumber - 1];
            if (!colDef) return;
            if (fmt === 'A') {
                cell.font      = headerStyleA.font;
                cell.alignment = headerStyleA.alignment;
                cell.border    = headerStyleA.border;
            } else {
                Object.assign(cell, makeHeaderStyleB(SKY_BLUE_COLS.has(colDef.fromRecord) ? HEADER_SKY : HEADER_DARK_PINK));
            }
        });

        const maxLengths = cols.map(c => c.header.length);

        data.forEach((r, idx) => {
            const rowData = {};
            cols.forEach((c, ci) => {
                const val    = r[c.fromRecord] ?? '';
                rowData[c.fromRecord] = val;
                const len = val != null && val !== '' ? String(val).length : 0;
                if (len > maxLengths[ci]) maxLengths[ci] = len;
            });

            const excelRow  = ws.addRow(rowData);
            excelRow.height = fmt === 'A' ? 15 : 20;

            excelRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                const colDef = cols[colNumber - 1];

                if (fmt === 'A') {
                    cell.font      = dataFont;
                    cell.alignment = { vertical: 'bottom', horizontal: 'center' };
                } else {
                    cell.font      = dataFont;
                    cell.border    = dataBorderB;
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    if (idx % 2 !== 0) cell.fill = altRowFillB;
                }

                if (!colDef) return;

                if (CURRENCY_COLS.has(colDef.fromRecord)) {
                    cell.numFmt    = CURRENCY_FMT;
                    cell.alignment = { ...cell.alignment, horizontal: 'right' };
                    if (cell.value !== '' && cell.value != null) {
                        const num       = Number(cell.value) || 0;
                        cell.value      = num;
                        const formatted = `₱${num.toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        if (formatted.length > maxLengths[colNumber - 1]) maxLengths[colNumber - 1] = formatted.length;
                    }
                }

                if (fmt === 'A') {
                    if (colDef.fromRecord === 'EmployeeName' || colDef.fromRecord === 'LoanDesc') {
                        cell.alignment = { horizontal: 'left', vertical: 'bottom' };
                    }
                } else {
                    if (colDef.fromRecord === 'EmployeeId')   cell.font = { ...dataFontBold, color: { argb: 'FF4E73DF' } };
                    if (colDef.fromRecord === 'EmployeeName') { cell.font = dataFontBold; cell.alignment = { ...cell.alignment, horizontal: 'left' }; }
                }
            });
        });

        cols.forEach((_, ci) => { ws.getColumn(ci + 1).width = Math.min(50, Math.max(12, maxLengths[ci] + 4)); });

        const buffer = await wb.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `LoanReport${fmt}_${facility}.xlsx`);
        showToast(`Exported ${data.length} record(s) — Format ${fmt}.`);
    };

    return (
        <div id="wrapper">
            <Navbar />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopNavbar />

                    {/* ── Toast Notification ── */}
                    {toast && (
                        <div style={{
                            position:        'fixed',
                            top:             20,
                            right:           20,
                            zIndex:          9999,
                            backgroundColor: toast.type === 'success' ? '#1cc88a' : toast.type === 'warn' ? '#f6c23e' : '#e74a3b',
                            color:           '#fff',
                            padding:         '12px 20px',
                            borderRadius:    '6px',
                            fontSize:        '13px',
                            fontWeight:      '600',
                            boxShadow:       '0 4px 16px rgba(0,0,0,0.15)',
                            maxWidth:        '360px',
                        }}>
                            <i className={`fas ${toast.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}`} style={{ marginRight: '8px' }}></i>
                            {toast.msg}
                        </div>
                    )}

                    <div className="container-fluid">

                        {/* ── Page Title ── */}
                        <div className="row justify-content-center mb-4">
                            <h4 className="m-0 font-weight-bold text-primary header-name">Loan Tracker</h4>
                        </div>

                        {/* ── Tab Bar ── */}
                        <div style={{ display: 'flex', marginBottom: '0', borderBottom: '2px solid #e3e6f0' }}>
                            {[
                                { fmt: 'A', label: 'Payroll Report A', sub: '3-UserID (PAGIBIG / SSS)',   accent: '#4e73df' },
                                { fmt: 'B', label: 'Payroll Report B', sub: 'Employee Wise Loan Details', accent: '#1cc88a' },
                            ].map(({ fmt, label, sub, accent: tabAccent }) => {
                                const isActive = activeTab === fmt;
                                return (
                                    <button
                                        key={fmt}
                                        onClick={() => setActiveTab(fmt)}
                                        style={{
                                            backgroundColor: isActive ? '#fff' : '#f8f9fc',
                                            color:           isActive ? tabAccent : '#858796',
                                            border:          'none',
                                            borderBottom:    isActive ? `3px solid ${tabAccent}` : '3px solid transparent',
                                            borderTop:       isActive ? '1px solid #e3e6f0'      : '1px solid transparent',
                                            borderLeft:      isActive ? '1px solid #e3e6f0'      : '1px solid transparent',
                                            borderRight:     isActive ? '1px solid #e3e6f0'      : '1px solid transparent',
                                            padding:         '12px 28px',
                                            cursor:          'pointer',
                                            fontWeight:      isActive ? '700' : '500',
                                            fontSize:        '13px',
                                            marginBottom:    isActive ? '-2px' : '0',
                                            display:         'flex',
                                            flexDirection:   'column',
                                            alignItems:      'flex-start',
                                            gap:             '2px',
                                            borderRadius:    '6px 6px 0 0',
                                            transition:      'all 0.15s',
                                        }}
                                    >
                                        <span>{label}</span>
                                        <span style={{ fontSize: '10px', fontWeight: '400', opacity: 0.75 }}>{sub}</span>
                                    </button>
                                );
                            })}

                            {/* Refresh Button */}
                            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', paddingBottom: '4px' }}>
                                <button
                                    onClick={fetchRecords}
                                    style={{ backgroundColor: '#f8f9fc', color: '#5a5c69', border: '1px solid #d1d3e2', borderRadius: '5px', padding: '6px 14px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                                >
                                    <i className={`fas fa-sync-alt${loading ? ' fa-spin' : ''}`}></i>
                                    {loading ? 'Loading...' : 'Refresh'}
                                </button>
                            </div>
                        </div>

                        {/* ── Tab Content ── */}
                        <div style={{ marginTop: '16px' }}>
                            {activeTab === 'A' && (
                                <TablePage
                                    fmt="A" records={records} loading={loading} fetchError={fetchError} fetchRecords={fetchRecords}
                                    search={searchA}      setSearch={setSearchA}
                                    filterMonth={filterMonthA} setFilterMonth={setFilterMonthA}
                                    filterYear={filterYearA}   setFilterYear={setFilterYearA}
                                    page={pageA} setPage={setPageA}
                                    doExport={doExport}
                                    onFilterChange={(month, year) => fetchRecords(month, year)}
                                />
                            )}
                            {activeTab === 'B' && (
                                <TablePage
                                    fmt="B" records={records} loading={loading} fetchError={fetchError} fetchRecords={fetchRecords}
                                    search={searchB}      setSearch={setSearchB}
                                    filterMonth={filterMonthB} setFilterMonth={setFilterMonthB}
                                    filterYear={filterYearB}   setFilterYear={setFilterYearB}
                                    page={pageB} setPage={setPageB}
                                    doExport={doExport}
                                    onFilterChange={(month, year) => fetchRecords(month, year)}
                                />
                            )}
                        </div>

                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default LoanTracker;